// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";

import avatarHelias from '../../img/dark-theme/helias-avatar.png'
//import avatarHelias from '../../img/dark-theme/helias-avatar-halloween.png'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");
var generalCommonJS = require("../../js/generalCommon.js")

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateAccountIDInstallation = endpointHelias+'/Helias/V0/Configuration/updateAccountIDInstallation';
const postInstallerBackToDashboard = endpointHelias+'/Helias/V0/General/postInstallerBackToDashboard';

const MainHeaderHELIAS = (params) => {

  useEffect(() => {    
    console.log("Cabecera cargada correctamente.")   

    cargarInstalacionActual() 
    if(window.location.href.includes("InstallerDashboard")){      
      document.getElementById("nombreInstalacionActual").className = "headline-03 installation-name fill"
    }
    else{            
      document.getElementById("buscadorInstalaciones").className = document.getElementById("buscadorInstalaciones").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("nombreInstalacionActual").className = document.getElementById("nombreInstalacionActual").className.replaceAll(" fill", "")    
      
      if( (dashboardCommonJS.comprobarPropiedadInstalacion() === false) && (generalCommonJS.obtenerEmailUsuario() !== "soporte@fevergy.com") ){        
        document.getElementById("liAdvisory").className = document.getElementById("liAdvisory").className.replaceAll(" hidden","") + " hidden"
        if(!localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
          document.getElementById("liInstallationConfiguration").className = document.getElementById("liInstallationConfiguration").className.replaceAll(" hidden","") + " hidden"        
          document.getElementById("liUserAccount").className = document.getElementById("liUserAccount").className.replaceAll(" hidden","") + " hidden"
        }
        else{

        }
      }
      else{        
        if(window.location.href.includes("Installer")){
          document.getElementById("liAdvisory").className = document.getElementById("liAdvisory").className.replaceAll(" hidden","") + " hidden"
        }
        else{
          document.getElementById("liAdvisory").className = document.getElementById("liAdvisory").className.replaceAll(" hidden","")
        }
        document.getElementById("liInstallationConfiguration").className = document.getElementById("liInstallationConfiguration").className.replaceAll(" hidden", "")        
        document.getElementById("liUserAccount").className = document.getElementById("liUserAccount").className.replaceAll(" hidden","")
      }
    }

  });

  function recuperarNombreUsuario(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  
    if (lastAuthUser !== null){  
      var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        
      userData = JSON.parse(userData);
    
      var email = ""
      
      for (var i = 0; i < userData.UserAttributes.length; i++) {
          if(userData.UserAttributes[i].Name === "name"){
              email = userData.UserAttributes[i].Value            
          }
      }
    
      return email
    }
    else{
      initialConfigCommonJS.gestionarRespuestaPeticionErronea("401")
    }
  }

  function cargarInstalacionActual(){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  
    if (lastAuthUser !== null){  
      var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")      
      var instalacion = ""      
      var idInstalacionActual = localStorage.getItem("installationId")
      var nombreInstalacion = ""      

      for (var i = 0; i < instalacionesDisponibles.length; i++) {
        instalacion = instalacionesDisponibles[i].split("·")
        if(idInstalacionActual === instalacion[0]){ nombreInstalacion = instalacion[1] }
      }

      document.getElementById("nombreInstalacionActual").innerHTML = nombreInstalacion.split("*")[1]

      if(instalacionesDisponibles.length > 1){
        if(localStorage.getItem("updateAccountIDInstallationColdStartHeating") === null){
          localStorage.setItem("updateAccountIDInstallationColdStartHeating", "true")
          dashboardCommonJS.precalentarLambda("updateAccountIDInstallation")
        }        
      }      
      
    }
    else{
      initialConfigCommonJS.gestionarRespuestaPeticionErronea("401")
    }

  }

  function seleccionarInstalacion(instalacion){
    
    generalCommonJS.registrarEventoAnalitica(ReactGA, 'CABECERA', 'SELECTOR - Cambio instalación', "", "")

    localStorage.removeItem("firstUpdateBasic")      

    instalacion = instalacion.split("|")

    if ( (instalacion[0] === "COMPLETED_USER") || (instalacion[0] === "COMPLETED_INSTALLER") ){
    
      document.getElementById("loaderGeneralAplicacion").className="loader overlay"
      
      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken") 
  
      //Actualizo en BBDD el la instalación seleccionada como la última usada
      var xhttp = new XMLHttpRequest();
      xhttp.open("POST", updateAccountIDInstallation, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify({ "IdToken": lastAuthUserIdToken,  "installationID": instalacion[1], "LastUsedInstallation": "true" });       
      
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {          
          console.log("Instalación marcada como última utilizada correctamente.")
          var jsonUpdateAccountIDInstallation = JSON.parse(this.responseText).body;  

          localStorage.setItem("installationId",jsonUpdateAccountIDInstallation.INSTALLATION_ID)            
          localStorage.setItem("installationName",jsonUpdateAccountIDInstallation.InstallationName)            
          localStorage.setItem("customizedWorkflow",jsonUpdateAccountIDInstallation.InstallationElements)    
          localStorage.removeItem("stripeData")
          if(jsonUpdateAccountIDInstallation.SUBSCRIPTION !== undefined){
            localStorage.setItem("stripeData",JSON.stringify(jsonUpdateAccountIDInstallation.SUBSCRIPTION))    
          }
          else{
            localStorage.setItem("stripeData",JSON.stringify({}))
          }
          
          localStorage.setItem("updateAccountIDInstallationColdStartHeating", "true")                  
          
          //Antes apuntaba a /Dashboard pero daba problemas de falsos positivos en plan no acorde a tu suscripción
          window.location.href = "/"
        }            
        if (this.readyState === 4 && this.status !== 200) {                        
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)                   
        }            
      };
      xhttp.send(data); 

      localStorage.removeItem("lastDashboardData")        
      localStorage.removeItem("lastSmartDevicesStatus")        
      localStorage.removeItem("forceUpdate")
      localStorage.removeItem("updateAccountIDInstallationColdStartHeating")                  
    }
    else{
      localStorage.removeItem("installationConfigurationMode")
      localStorage.setItem("installationToContinueConfiguration",instalacion[1])
      window.location.href="/"
    }
    
  }

  const listadoInstalaciones = localStorage.getItem("availableInstallations").split("|").map((instalacion,index) =>
    <React.Fragment key={instalacion}>  
      { localStorage.getItem('installationId') === instalacion.split("·")[0] ? 
        <input type="radio" id={"radio"+index} name="radio-noicons" onClick={() => seleccionarInstalacion(instalacion.split("·")[2]+"|"+instalacion.split("·")[0])} defaultChecked/>
      :
        <input type="radio" id={"radio"+index} name="radio-noicons" onClick={() => seleccionarInstalacion(instalacion.split("·")[2]+"|"+instalacion.split("·")[0])} />
      }
        <label className="icon-wrapper" htmlFor={"radio"+index}>
          <figure className="avatar size-m"><span className="material-icon green">{dashboardCommonJS.obtenerIconoInstalacion(instalacion.split("·")[1].split("*")[0])}</span></figure>
          <span id={"spanNombreInstalacion"+index} className="label">{instalacion.split("·")[1].split("*")[1]}</span>                  
        </label>    
    </React.Fragment>   
  );  
  
  function cerrarSelectorInstalacion(){    
    document.getElementById("divSelectorInstalacion").className = document.getElementById("divSelectorInstalacion").className.replaceAll(" hidden", "") + " hidden"    
  }

  function volverAConsolaInstalador(){

    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken") 

    //Actualizo en BBDD el la instalación seleccionada como la última usada
    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", postInstallerBackToDashboard, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify({"installerAccountID":localStorage.getItem("accountID"),"installationID":localStorage.getItem("installationId")});       
    
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {          
        console.log("Volviendo a la listado de instalaciones.")
        
        localStorage.removeItem("lastDashboardData")        
        localStorage.removeItem("lastSmartDevicesStatus")        
        localStorage.removeItem("forceUpdate")
        localStorage.removeItem("updateAccountIDInstallationColdStartHeating")           
        localStorage.setItem("installerMode", "true")

        //Redirijo a la instalación
        window.location.href = "/"
      }            
      if (this.readyState === 4 && this.status !== 200) {                        
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)                   
      }            
    };
    xhttp.send(data); 

  }

  return (     
    <>
    { localStorage.getItem("installationName").includes("INSTALADOR") && !window.location.href.includes("Installer") ?
      <div className="installer-preheader">
        <div className="wrapper">
          <button id="volverConsolaInstalador" className="link" onClick={() => volverAConsolaInstalador()}><span className="material-icon">arrow_back</span>Volver a listado de instalaciones</button>
        </div>
      </div>
    :
      <></>
    }

    <header id="cabeceraHelias" className="wrapper private-header">        
      
      <div className="menu-installation wrap">
        <nav id="menuPrincipal" className="private-menu" >
          
          <figure className="menu-trigger helias-menu" >
            <span id="cuentaRegresivaAvatar" className="material-icon size-m">menu</span>            
          </figure>
          
          <div className="bubble menu-list">
            
            <div className="wrapper welcome"> 

                <figure className="welcome-helias">
                  <img src={avatarHelias} alt="Helias"/>
                </figure>
                <span className="welcome-name">Hola {recuperarNombreUsuario()}</span>

                <button className="button link close">
                  <span className="material-icon">highlight_off</span>
                </button>

            </div>

            <ul className="wrapper list">
              
              <li id="liDashboard"><button id="opcionMenuDashboard" className="button secondary list full-width current"><span className="material-icon">home</span><span id="opcionMenuLiteralDashboard">Inicio</span></button></li>                                    

              {/* OPCIONES DE MENÚ OCULTAS en Main.js User linea 85*/}
              <li id="liHeliasAnalytics"><button id="opcionMenuHeliasAnalytics" className="button secondary list full-width"><span className="material-icon">signal_cellular_alt</span><span id="opcionMenuLiteralHeliasAnalytics">Histórico</span></button></li>
              <li id="liHistoricalEconomics"><button id="opcionMenuHistoricalEconomics" className="button secondary list full-width"><span className="material-icon">bar_chart</span><span id="opcionMenuHistoricalEconomics">Histórico económico</span></button></li>
              <li id="liRules"><button id="opcionMenuRules" className="button secondary list full-width" ><span className="material-icon">rule</span><span id="opcionMenuLiteralRules">Reglas</span></button></li>            
              <li id="liInstallationActivity"><button id="opcionMenuInstallationActivity" className="button secondary list full-width" ><span className="material-icon">fact_check</span><span id="opcionMenuLiteralInstallationActivity">Actividad</span></button></li>              
              {/* OPCIONES DE MENÚ OCULTAS - ELIMINAR SI RESULTA EN LA VERSIÓN FINAL*/}

              <li id="liAdvisory"><button id="opcionMenuAdvisory" className="button secondary list full-width" ><span className="material-icon">tips_and_updates</span><span id="opcionMenuLiteralAdvisory">Asesoramiento</span></button></li>                        
              <li className="with-divider bold-divider"></li>
              <li id="liInstallationConfiguration"><button id="opcionMenuInstallationConfiguration" className="button secondary list full-width" ><span className="material-icon">settings</span><span id="opcionMenuLiteralInstallationConfiguration">Configuración</span></button></li>                          
              <li id="liUserAccount"><button id="opcionMenuUserAccount" className="button secondary list full-widths" ><span className="material-icon">person</span><span id="opcionMenuLiteralUserAccount">Cuenta de usuario</span></button></li>                                        
              <li id="liSupport"><button id="opcionMenuSupport" className="button secondary list full-widths" ><span className="material-icon">support_agent</span><span id="opcionMenuLiteralSupport">Ayuda y soporte</span></button></li>                          
              <li id="liCookies"><button id="opcionMenuCookies" className="button secondary list full-widths" ><span className="material-icon">cookie</span><span id="opcionMenuLiteralCookies">Privacidad</span></button></li>                          
              <li id="liLogout"><button id="opcionMenuLogout" className="button secondary list full-width" ><span className="material-icon">logout</span><span id="opcionMenuLiteralLogout">Salir</span></button></li>
            </ul>

            <div id="contadorRefrescoInformativo" className="wrapper last-access">                  
              { localStorage.getItem("installationName").includes("INSTALADOR") ?
                <span className="size-s clarification hidden" >Último acceso: {dashboardCommonJS.formatearAFechaHoraCorta(localStorage.getItem("lastAccess"), "UTC")}</span>
                :
                <></>
              }
              
              { generalCommonJS.obtenerEmailUsuario() === "soporte@fevergy.com" ?                
                <div>
                  <span className="size-s clarification" >Última actualización:</span>
                  <span className="size-s clarification" id="labelTiempoUltimaActualizacion"/>                  
                </div>
                :
                <></>
              }              
            </div>

          </div>

        </nav>

        { (localStorage.getItem("availableInstallations").split("|").length > 1) && (!localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")) ?
          <h1 className="headline-03 installation-name" onClick={() => document.getElementById("divSelectorInstalacion").className = document.getElementById("divSelectorInstalacion").className.replaceAll(" hidden", "")}>
            <span id="nombreInstalacionActual" className="headline-03 title fill"></span>
            <span className="material-icon">unfold_more</span>
          </h1>
        :
          <span id="nombreInstalacionActual" className="headline-03 installation-name fill"></span>
        }



        <button id="divIconoRefrescarDashboard" className="force-update button hidden">
          <span id="iconoRefrescoDashboard" className="material-icon">autorenew</span>          
        </button>

        <fieldset id="buscadorInstalaciones">        
          <fieldset className="search automatic">
            <input type="search" id="search" spellCheck="false" autoComplete="off" placeholder="Buscar instalación..." onKeyUp={() => dashboardCommonJS.filtrarInstalaciones()}/> 
            <span className="material-icon icon-wrapper" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("search","INSTALACIONES_INSTALADOR")}></span>
          </fieldset>
        </fieldset>

      </div>

      <div id="divSelectorInstalacion" className="loader installations-list hidden">

          <button className="link close" onClick={() => cerrarSelectorInstalacion() }><span className="material-icon">highlight_off</span></button>

          <section className="wrapper">
            <fieldset className="radio multiple no-check">
              <legend>Instalaciones</legend>
                {
                  listadoInstalaciones
                }
            </fieldset>
          </section>

      </div>

    </header>
    </>
  )
}

export default MainHeaderHELIAS